import {
  SocialButton
} from "../chunk-TY4DM4QD.mjs";
import "../chunk-7CU25RIV.mjs";

// src/social-buttons/social-button-google.tsx
import * as React from "react";
import { systemForwardRef } from "@stepstone-genesis/system";
import { GoogleLoginColouredIcon } from "@stepstone-genesis/icons";
var SocialGoogleButton = systemForwardRef(
  function SocialGoogleButton2({ children, ...props }, ref) {
    var _a;
    const defaultLabel = "Log in with Google";
    return /* @__PURE__ */ React.createElement(
      SocialButton,
      {
        ref,
        element: "SOCIAL_GOOGLE_BUTTON",
        ...props,
        iconBefore: /* @__PURE__ */ React.createElement(GoogleLoginColouredIcon, null),
        a11yLabel: (_a = props.a11yLabel) != null ? _a : defaultLabel
      },
      children != null ? children : defaultLabel
    );
  }
);
export {
  SocialGoogleButton
};
